import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";
import Title from "@streeteasy/design-system/deprecated/Title";

import {
  largeScreen,
  xSmallScreen
} from "../../../../shared/constants/screenSizes";

const ActionBox = styled.div`
  width: 90px;
  @media screen and (max-width: ${largeScreen}px) {
    button {
      height: 40px;
      line-height: 38px;
    }
  }
`;

const Container = styled.div`
  background: ${colors.primary};
  display: flex;
  margin: 0 0 15px;
  padding: 20px;

  @media screen and (max-width: ${largeScreen}px) {
    justify-content: space-between;
    margin: 3px 0 15px;
  }

  @media screen and (max-width: ${xSmallScreen}px) {
    align-items: center;
    flex-direction: column;
    padding: 20px 20px 18px;
  }
`;

const TextBox = styled.div`
  width: 260px;

  @media screen and (max-width: ${largeScreen}px) {
    text-align: left;
    width: auto;
  }

  @media screen and (max-width: ${xSmallScreen}px) {
    margin-bottom: 12px;
    text-align: center;
  }
`;

const UITitle = styled(Title)`
  color: white;
  line-height: 1.4;
`;

const UIText = styled(Text)`
  color: white;
  line-height: 1.3;
`;

Container.displayName = "Container";

export { ActionBox, Container, TextBox, UITitle, UIText };
